var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-grid mt-2 mt-sm-0"},[(_vm.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('v-row',_vm._l((_vm.products),function(product,index){return _c('v-col',{key:product.productId,staticClass:"product-col",attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('ProductCard',{attrs:{"product":product,"position":_vm.initPosition + index},on:{"selectProduct":function($event){return _vm.$emit('selectProduct', {
            product: product,
            index: _vm.initPosition + index
          })}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }